import { constrainColumns } from "./column-constraints";
import { Component, SyntheticEvent } from "react";
import { SwitchInput } from "../../forms";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { toLiteral } from "../../../../helper/locale-utils";
import Dropdown, { DropdownButton, DropdownMenu } from "@adeccoux/tag-ds/dropdown";

const getItemStyle = (isDragging: any, draggableStyle: any) => ({
  userSelect: "none",
  background: isDragging ? "var(--backgrounds-02)" : "",
  ...draggableStyle,
});

interface TableConfigurationProps {
  columns: any[];
  defaultColumns: any[];
  changeColumns: Function;

  handleResetTable?: Function;
}
export interface IState {
  [others: string]: any;
}
class TableConfigurationDropdown extends Component<TableConfigurationProps> {
  constructor(props: any) {
    super(props);
    this.state = {
      defaultColumns: this.props.defaultColumns,
      columns: this.props.columns,
    };
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  componentDidUpdate(previous: TableConfigurationProps) {
    if (previous.columns !== this.props.columns) this.setState({ columns: this.props.columns });
  }

  onDragEnd(result: any) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const currentState: any = this.state;
    if (currentState.columns[result.source.index]?.disableReorder) return;
    const columns = this.reorder(currentState.columns, result.source.index, result.destination.index);

    this.changeColumns(columns);
  }

  onToggle(item: any, e: SyntheticEvent) {
    if (item.disableReorder) return;
    item = { ...item };
    const self = this;

    if (typeof item.displayed === "undefined" || item.displayed === true) {
      item.displayed = false;
    } else {
      item.displayed = true;
    }
    const currentState: any = self.state;
    const columns = [...currentState.columns];
    const indexOfElementToReplace = currentState?.columns?.findIndex((el: any) => el.columnKey === item.columnKey);
    if (indexOfElementToReplace !== -1) {
      columns[indexOfElementToReplace] = item;
    }

    this.changeColumns(columns);
  }

  changeColumns(columns: any) {
    columns = constrainColumns(columns, this.props.defaultColumns);
    const self = this;
    this.setState(
      {
        columns,
      },
      function () {
        if (typeof self.props.changeColumns === "function") {
          self.props.changeColumns(columns);
        }
      }
    );
  }

  reorder = (list: any, startIndex: any, endIndex: any) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return constrainColumns(result, this.props.defaultColumns);
  };

  render() {
    const currentState: any = this.state;
    return (
      <Dropdown className="tag-ds" id="results-table-configuration-dropdown">
        <DropdownButton className="toggle-table-view link">
          {toLiteral({ id: "Table View" })}
          <span className="material-icons right">view_week</span>
        </DropdownButton>
        <DropdownMenu onClick={(e: any) => e.stopPropagation()}>
          <ul>
            <DragDropContext onDragEnd={this.onDragEnd}>
              <Droppable droppableId="droppable">
                {(provide) => (
                  <div {...provide.droppableProps} ref={provide.innerRef}>
                    {currentState.columns &&
                      currentState.columns?.map((item: any, index: number) => (
                        <Draggable key={item.columnKey} draggableId={item.columnKey} index={index} isDragDisabled={Boolean(item.disableReorder)}>
                          {(provided, snapshot) => (
                            <li
                              className={`table-configuration-item dropdown-item-icon flex align-items_center ${item.title ? "" : "hidden"}`}
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                            >
                              <span className="material-icons">drag_indicator</span>

                              <SwitchInput
                                small
                                disabled={Boolean(item.disableReorder)}
                                checked={typeof item.displayed === "undefined" || item.displayed === true}
                                label={item.title}
                                value={item.columnKey}
                                onChange={(e: any) => this.onToggle(item, e)}
                              />
                            </li>
                          )}
                        </Draggable>
                      ))}
                    {provide.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </ul>
        </DropdownMenu>
      </Dropdown>
    );
  }
}

export default TableConfigurationDropdown;
